import * as React from 'react'
import CardWrapper from 'Components/new/community-card/card-wrapper'
import Header from 'Components/new/community-card/header'
import CarModel from 'Components/new/community-card/car-model'
import Text, {
  JHLabel,
  QALabel,
  TopicLabel,
} from 'Components/new/community-card/text'
import Video from 'Components/new/community-card/video'
import ImageList from 'Components/new/community-card/image-list'
import Forward, {
  forwardEmpty,
  questionEmpty,
} from 'Components/new/community-card/forward'
import Answer from 'Components/new/community-card/answer'
import Interact, { isBuryable } from 'Components/new/community-card/interact'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import ARTICLE_CONTENT_TYPE from 'Constants/articleType'
import koubeiLink from 'Components/new/links/koubei-link'
import ugcDetailLink from 'Components/new/links/ugc-detail-link'
import Share from 'Components/new/community-card/share'
import anyLink from 'Components/new/links/any-link'
import { filterEmoji } from 'Constants/emoji'
import { isLowContent, substrSingleByte } from 'New/ugc/tdk'
interface IUGCItemProps {
  data: any
  teaParams?: Record<string, string>
  sort?: string
  displayCommunity?: boolean
  shareWithZT?: boolean
  onClickCommunity?(): void
}

// eslint-disable-next-line complexity
const UGCItem: React.FC<IUGCItemProps> = ({
  data,
  teaParams,
  sort,
  displayCommunity = false,
  shareWithZT = true,
  onClickCommunity,
}) => {
  const {
    gid_str,
    title,
    content,
    article_sub_type,
    selected_level,
    image_urls,
    comment_data,
    comment_count,
    create_time,
    latest_comment_time,
    display_time,
    digg_count,
    user_digg,
    user_bury,
    is_collect,
    activity_info,
  } = data || {}

  const isAsk = article_sub_type === 8

  const isKoubei = [12, 13, 14].includes(article_sub_type)

  const {
    avatar_url,
    user_id,
    name,
    is_follow,
    medal_list,
    user_description_list,
    motor_auth_show_info,
  } = data?.profile_info || {}

  const { auth_v_type } = motor_auth_show_info || {}

  const { video_id, cover_url } = data?.video_detail_info || {}

  const alt = title
    ? title
    : isLowContent(content)
    ? name
    : substrSingleByte(content, 10)

  const {
    item_id_str: link_info_id,
    title: link_info_title,
    ui_style: link_info_ui_style,
    name: link_info_name,
    image_url: link_info_image_url,
    article_type: link_info_article_type,
  } = data?.link_info || {}

  const {
    status: ugc_question_info_status,
    status_display: ugc_question_info_status_display,
    send_award,
    award_icon_url,
  } = data?.ugc_question_info || {}

  const firstComment = comment_data?.[0]

  const hasAnswer = isAsk && ugc_question_info_status === 1 && firstComment

  const textLinkTitle = substrSingleByte(filterEmoji(content), 20)
  const makeArticleLinkWrapper = (isPinglun: boolean, hasTitle?: boolean) => {
    return isKoubei
      ? koubeiLink({
          id: gid_str,
          anchorId: isPinglun ? 'comment' : '',
          title: hasTitle ? textLinkTitle : undefined,
        })
      : ugcDetailLink({
          id: gid_str,
          anchorId: isPinglun ? 'comment' : '',
          title: hasTitle ? textLinkTitle : undefined,
        })
  }

  const mergedTeaParams = {
    ...teaParams,
    group_id: gid_str,
    author_id: String(user_id),
  }

  const { activity_id_str, name: activity_name } = activity_info || {}

  return (
    <CardWrapper
      className="tw-px-16 tw-py-20 tw-mt-12 tw-bg-white"
      onClick={() => {
        sendTeaCommEvent('clk_event', {
          event_id: 'content_region_clk',
          module_id: 'ugc_anthor',
          content_type: ARTICLE_CONTENT_TYPE[article_sub_type]?.value,
          ...mergedTeaParams,
        })
      }}
    >
      <Header
        avatar={avatar_url}
        userId={user_id}
        username={name}
        userVerified={!!auth_v_type}
        verifyType={auth_v_type}
        followed={is_follow}
        medals={medal_list?.slice(0, 3)?.map((d: any) => ({
          name: d.desc_content,
          icon: d.icon_url,
          desc: d.empathy,
          time: d.upgrade_time,
        }))}
        medalsVisible
        textTags={user_description_list
          ?.slice(0, 1)
          ?.map((d: any) => d.description)}
        onClickUser={() => {
          sendTeaCommEvent('clk_event', {
            event_id: 'article_anthor_head_picture',
            module_id: 'ugc_anthor',
            content_type: ARTICLE_CONTENT_TYPE[article_sub_type]?.value,
            ...mergedTeaParams,
          })
        }}
        onClickFollow={(status) =>
          sendTeaCommEvent(status ? 'rt_unfollow' : 'rt_follow', {
            event_id: `content_${status ? 'unfollow' : 'follow'}_button_clk`,
            module_id: 'ugc_anthor',
            hudong_position: '0',
            ...mergedTeaParams,
          })
        }
      />
      <CarModel />
      <Text
        title={title}
        content={
          isKoubei || article_sub_type === 9 ? content?.slice(0, 120) : content
        }
        prepend={
          <React.Fragment>
            {isAsk ? <QALabel>提问</QALabel> : null}
            {selected_level ? <JHLabel type={selected_level} /> : null}
            <TopicLabel id={activity_id_str}>{activity_name}</TopicLabel>
          </React.Fragment>
        }
        append={
          isKoubei || article_sub_type === 9 ? (
            <span className="tw-text-common-blue tw-whitespace-nowrap">
              ...查看全文
            </span>
          ) : null
        }
        linkWrapper={makeArticleLinkWrapper(false, true)}
      />
      <Video
        groupId={gid_str}
        videoId={video_id}
        coverUrl={cover_url}
        coverAlt={`${alt}${gid_str}视频`}
        type={article_sub_type === 6 ? 2 : 1}
      />
      {!video_id || !cover_url ? (
        <ImageList
          imageList={image_urls?.map(
            (
              image: { url: string; width: number; height: number },
              index: number
            ) => {
              return {
                src: image.url,
                width: image.width,
                height: image.height,
                alt: `${alt}图${image_urls.length > 1 ? index + 1 : ''}`,
              }
            }
          )}
        />
      ) : null}
      {link_info_id ? (
        <Forward
          username={link_info_name}
          title={link_info_title}
          coverUrl={link_info_image_url}
          errorImg={isAsk ? questionEmpty : forwardEmpty}
          uiStyle={link_info_ui_style}
          linkWrapper={anyLink({
            id: link_info_id,
            articleType: link_info_article_type,
          })}
        />
      ) : null}
      {hasAnswer ? (
        <Answer
          text={firstComment?.text}
          labelUrl={firstComment?.label_url}
          avatar={firstComment?.user_info?.avatar_url}
          userId={firstComment?.user_info?.user_id}
          username={firstComment?.user_info?.name}
          userVerified={!!firstComment?.user_info?.auth_info?.auth_v_type}
          verifyType={firstComment?.user_info?.auth_info?.auth_v_type}
          linkWrapper={makeArticleLinkWrapper(false)}
        />
      ) : null}
      <Interact
        id={gid_str}
        diggType={article_sub_type === 11 ? 'comment' : 'community'}
        commentText={isAsk ? '回答' : '评论'}
        commentCount={comment_count}
        time={
          sort === 'reply' ? latest_comment_time || display_time : display_time
        }
        timeAppend={sort === 'reply' && latest_comment_time ? '回复' : ''}
        awardText={send_award}
        awardIcon={award_icon_url}
        questionStatus={ugc_question_info_status}
        questionDisplay={ugc_question_info_status_display}
        diggCount={digg_count}
        selfHasDigg={user_digg}
        buried={user_bury}
        buryVisible={isBuryable(article_sub_type)}
        groupId={gid_str}
        articleType={article_sub_type}
        collectVisible={![0, 12, 13, 14].includes(article_sub_type)}
        diggVisible={!isAsk}
        collected={is_collect}
        onClickCommunity={onClickCommunity}
        commentLinkWrapper={makeArticleLinkWrapper(true)}
        communityId={displayCommunity ? data?.community_info?.motor_id_str : ''}
        communityName={displayCommunity ? data?.community_info?.motor_name : ''}
        shareContent={({ close }) => (
          <Share
            url={`https://www.dongchedi.com/ugc/article/${gid_str}${
              shareWithZT ? '?zt=pc_redirect' : ''
            }`}
            title={title}
            onCopySuccess={close}
            onShare={(text) => {
              sendTeaCommEvent('clk_event', {
                event_id: 'ugc_fenxiang',
                author_id: user_id,
                hudong_position: '0',
                group_id: gid_str,
                obj_text: text,
              })
            }}
          />
        )}
        onClickDigg={(status) => {
          sendTeaCommEvent(status ? 'rt_unlike' : 'rt_like', {
            hudong_position: '0',
            content_type: ARTICLE_CONTENT_TYPE[article_sub_type]?.value,
            module_id: 'ugc_anthor',
            ...mergedTeaParams,
          })
        }}
        onClickComment={() => {
          sendTeaCommEvent('rt_reply_comment', {
            hudong_position: '0',
            content_type: ARTICLE_CONTENT_TYPE[article_sub_type]?.value,
            module_id: 'ugc_anthor',
            ...mergedTeaParams,
          })
        }}
        onClickCollect={(status) => {
          sendTeaCommEvent(status ? 'rt_not_favourite' : 'rt_favourite', {
            hudong_position: '0',
            content_type: ARTICLE_CONTENT_TYPE[article_sub_type]?.value,
            module_id: 'ugc_anthor',
            ...mergedTeaParams,
          })
        }}
      />
    </CardWrapper>
  )
}
export default UGCItem
